export const suggestionEntityTypes = ['riskAssessments', 'contracts', 'partners'];
